import React from "react";

interface IHeightWithBottomDistanceProps{
    children?: React.ReactNode,
    bottomDistance?: number
}

export const HeightWithBottomDistance: React.FC<IHeightWithBottomDistanceProps> = ({ children, bottomDistance = 9 }) => {
    return (
        <div style={{ height: `calc(100vh - ${bottomDistance}rem)`}}>
            {children}
        </div>
    );
}